export const TRUEMED_QUALIFICATION_ID = process.env.TRUEMED_QUALIFICATION_ID ?? '';
export const TRUEMED_SCRIPT_URL = process.env.TRUEMED_WIDGET_URL ?? '';